// extracted by mini-css-extract-plugin
export default {"info":"Index_info__qF-cl","infoList":"Index_infoList__jZfpT","titleTooltip":"Index_titleTooltip__HohVS"};